'use es6';

import * as ActionTypes from './ActionTypes';
import * as ecosystemClient from '../clients/ecosystemClient';
import * as qualityClient from '../clients/qualityClient';
import I18n from 'I18n';
const notificationsKey = 'appMarketplace.detail.reviews';
export const submitReview = (review, slug) => dispatch => {
  dispatch({
    type: ActionTypes.REVIEW_WRITE_REQUESTED
  });
  dispatch({
    type: ActionTypes.NEW_REVIEW_SUBMITTED,
    payload: review,
    meta: {
      slug
    }
  });
  return ecosystemClient.writeReview(review).then(resp => {
    dispatch({
      type: ActionTypes.REVIEW_WRITE_RECEIVED,
      payload: resp
    });
    return resp;
  }).catch(err => {
    dispatch({
      type: ActionTypes.REVIEW_WRITE_FAILED
    });
    throw err;
  });
};
export const setReviewHelpful = (reviewId, userId, isHelpful) => dispatch => {
  dispatch({
    type: ActionTypes.REVIEW_HELPFUL_REQUESTED
  });
  return ecosystemClient.toggleReviewHelpful(reviewId, isHelpful).catch(err => {
    dispatch({
      type: ActionTypes.REVIEW_HELPFUL_FAILED,
      payload: err,
      meta: {
        notification: {
          type: 'danger',
          titleText: I18n.text(`${notificationsKey}.helpful.error.titleText`),
          message: I18n.text(`${notificationsKey}.helpful.error.message`)
        }
      }
    });
  });
};
export const reportReview = ({
  reviewId,
  reportReason,
  comment
}) => dispatch => {
  dispatch({
    type: ActionTypes.REVIEW_REPORT_REQUESTED
  });
  return qualityClient.reportReview({
    reviewId,
    reportReason,
    comment
  }).then(resp => {
    dispatch({
      type: ActionTypes.REVIEW_REPORT_RECEIVED,
      payload: resp,
      meta: {
        notification: {
          titleText: I18n.text(`${notificationsKey}.reportModal.success.titleText`),
          message: I18n.text(`${notificationsKey}.reportModal.success.message`)
        }
      }
    });
  }).catch(err => {
    const alreadyReported = err.responseJSON && err.responseJSON.message && err.responseJSON.message.includes('already reported');
    const errorKey = alreadyReported ? 'duplicate_error' : 'error';
    dispatch({
      type: ActionTypes.REVIEW_REPORT_FAILED,
      payload: err,
      meta: {
        notification: {
          type: 'danger',
          titleText: I18n.text(`${notificationsKey}.reportModal.${errorKey}.titleText`),
          message: I18n.text(`${notificationsKey}.reportModal.${errorKey}.message`)
        }
      }
    });
  });
};
export const reportReply = ({
  reviewId,
  replyId,
  reportReason,
  comment
}) => dispatch => {
  dispatch({
    type: ActionTypes.REVIEW_REPORT_REPLY_REQUESTED
  });
  return qualityClient.reportReply({
    reviewId,
    replyId,
    reportReason,
    comment
  }).then(resp => {
    dispatch({
      type: ActionTypes.REVIEW_REPORT_REPLY_RECEIVED,
      payload: resp,
      meta: {
        notification: {
          titleText: I18n.text(`${notificationsKey}.reportModal.success.titleText`),
          message: I18n.text(`${notificationsKey}.reportModal.success.message`)
        }
      }
    });
  }).catch(err => {
    const alreadyReported = err.responseJSON && err.responseJSON.message && err.responseJSON.message.includes('already reported');
    const errorKey = alreadyReported ? 'duplicate_error' : 'error';
    dispatch({
      type: ActionTypes.REVIEW_REPORT_REPLY_FAILED,
      payload: err,
      meta: {
        notification: {
          type: 'danger',
          titleText: I18n.text(`${notificationsKey}.reportModal.${errorKey}.titleText`),
          message: I18n.text(`${notificationsKey}.reportModal.${errorKey}.message`)
        }
      }
    });
  });
};